// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 14", width: "20", height: "14" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { fillRule: "nonzero" },
                React.createElement("path", { d: "M846,1951 C840.4775,1951 836,1956.83333 836,1958 C836,1959.16667 840.4775,1965 846,1965 C851.5225,1965 856,1959.16667 856,1958 C856,1956.83333 851.5225,1951 846,1951 Z M846,1961 C844.34325,1961 843,1959.65675 843,1958 C843,1956.34325 844.34325,1955 846,1955 C847.65675,1955 849,1956.34325 849,1958 C849,1959.65675 847.65675,1961 846,1961 Z", transform: "translate(-836 -1951)" })))));
};
Icon.displayName = 'Eye20x14';
export default Icon;
//# sourceMappingURL=Eye20x14.js.map